const drillsCalls = {
  async api_tags_get_get({ dispatch }, { endpoint, mutation, apiVersion }) {
    return dispatch('api_call', {
      method: 'GET',
      apiVersion,
      endpoint,
      mutation,
      hasCancel: false,
    })
  },
  async api_tags_get_post({ dispatch }, { item, endpoint, action, apiVersion, ...rest }) {
    dispatch('api_call', {
      method: 'POST',
      apiVersion,
      endpoint,
      action,
      actionArgs: { item, ...rest },
      hasCancel: false,
      data: item,
    })
  },
  async api_tags_get_patch({ dispatch }, { item, endpoint, action, apiVersion, ...rest }) {
    dispatch('api_call', {
      method: 'PATCH',
      apiVersion,
      endpoint: `${endpoint}${item.id}/`,
      action,
      hasCancel: false,
      actionArgs: { item, ...rest },
      data: item,
    })
  },
  async api_tags_get_delete({ dispatch }, { item, endpoint, action, apiVersion, ...rest }) {
    dispatch('api_call', {
      method: 'DELETE',
      apiVersion,
      endpoint: `${endpoint}${item.id}/`,
      action,
      hasCancel: false,
      actionArgs: { item, ...rest },
    })
  },
}

export default drillsCalls
